var _circle, _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 18,
    stroke: "#444444",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 26C34.5 31.1251 33.4592 35.7156 31.8231 38.9878C30.1571 42.3198 28.0405 44 26 44C23.9595 44 21.8429 42.3198 20.1769 38.9878C18.5408 35.7156 17.5 31.1251 17.5 26C17.5 20.8749 18.5408 16.2844 20.1769 13.0122C21.8429 9.68017 23.9595 8 26 8C28.0405 8 30.1571 9.68017 31.8231 13.0122C33.4592 16.2844 34.5 20.8749 34.5 26Z",
    stroke: "#444444",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.11145,
    y1: 20.7778,
    x2: 42.8892,
    y2: 20.7778,
    stroke: "#444444",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.11145,
    y1: 33.4443,
    x2: 42.8892,
    y2: 33.4443,
    stroke: "#444444",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.2e275eaed2c4c1f3ae15a821cd545dd7.svg";
export { ForwardRef as ReactComponent };